<template>
  <div class="subcategory download-page" :class="pageTypeClass">
    <navigation :subcategory="subcategoryData" :category-name="categoryName" />
    <div class="content download-page__content">
      <div class="container">
        <div class="card">
          <NuxtPage :subcategory="subcategoryData" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '~/stores/main';
  import Navigation from '~/components/ui/Navigation.vue';

  definePageMeta({ middleware: ['check-downloads-url'] });

  const store = useMainStore();
  const route = useRoute();
  const categories = computed(() => store.categories);
  const baseUrlMedia = computed(() => store.baseUrlMedia);
  const subcategoryData = computed(() => store.subcategoryData);

  // Make route params reactive
  const currentCategory = computed(() => (Array.isArray(route.params.category) ? route.params.category[0] : route.params.category));
  const currentSubcategory = computed(() =>
    Array.isArray(route.params.subcategory) ? route.params.subcategory[0] : route.params.subcategory
  );

  function findNodeIdIndexInArray(arr: any[], nodeId: string | number): number {
    if (!arr) return -1;
    return arr.findIndex((item: any) => item.nodeId === nodeId);
  }

  const categoryIndex = computed(() => findNodeIdIndexInArray(categories.value, currentCategory.value));
  const categoryName = computed(() => {
    if (
      categories.value &&
      categories.value.length &&
      categoryIndex.value > -1 &&
      categories.value[categoryIndex.value] &&
      categories.value[categoryIndex.value].external &&
      typeof categories.value[categoryIndex.value].external === 'object'
    ) {
      return (categories.value[categoryIndex.value].external as any)?.title || '';
    } else {
      return '';
    }
  });
  const pageTypeClass = computed(() => {
    let pageType = subcategoryData.value && subcategoryData.value.publishedTo;
    switch (pageType) {
      case 1:
        return 'product-page_external';
      case 2:
        return 'product-page_internal';
      case 3:
        return 'product-page_service';
      default:
        return '';
    }
  });

  // Load initial data before useAsyncData (so immediate: false works)
  if (route.path && route.path.startsWith('/downloads')) {
    if (!Array.isArray(categories.value) || categories.value.length === 0) {
      await store.serverInit({ route, params: route.params });
    }
    await store.setDownloadsPageData({ params: route.params });
  }

  // Ensure data is loaded (SSR + CSR) - reactive to route changes
  const { data: subcategoryResult } = await useAsyncData(
    `downloadsSubcategory-${currentCategory.value}-${currentSubcategory.value}`,
    async () => {
      if (!Array.isArray(categories.value) || categories.value.length === 0) {
        await store.serverInit({ route, params: route.params });
      }
      await store.setDownloadsPageData({ params: route.params });
      return store.subcategoryData;
    },
    {
      watch: [currentCategory, currentSubcategory],
      immediate: false // Prevents duplicate call on mount since we pre-loaded above
    }
  );

  function setDataLayersPages() {
    // Implement logic for data layers if needed
  }

  onMounted(() => {
    setDataLayersPages();
  });
</script>
